/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    Node,
    NodeFromJSON,
    NodeFromJSONTyped,
    NodeToJSON,
    NodeListAllOf,
    NodeListAllOfFromJSON,
    NodeListAllOfFromJSONTyped,
    NodeListAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface NodeList
 */
export interface NodeList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof NodeList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof NodeList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {string}
     * @memberof NodeList
     */
    entity_id: string;
    /**
     * 
     * @type {Array<Node>}
     * @memberof NodeList
     */
    nodes: Array<Node>;
}

export function NodeListFromJSON(json: any): NodeList {
    return NodeListFromJSONTyped(json, false);
}

export function NodeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodeList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'entity_id': json['entity_id'],
        'nodes': ((json['nodes'] as Array<any>).map(NodeFromJSON)),
    };
}

export function NodeListToJSON(value?: NodeList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'entity_id': value.entity_id,
        'nodes': ((value.nodes as Array<any>).map(NodeToJSON)),
    };
}


